import {
	RETURN_CUSTOMER_CODE,
  RETURN_CUSTOMER_CODE_FAIL,
	GetCustomerCodeState   
  } from "../../domain/trustPicker/index";

export const initialState: GetCustomerCodeState = {
  result: [
    {
      id: "0",
      label: "Empty list",
    }]
};

export default function returnCustomerCode(state = initialState, action: any) { 
  switch (action.type) {
    case RETURN_CUSTOMER_CODE:
      return {
        ...state,
        result: action.payload
      };
    case RETURN_CUSTOMER_CODE_FAIL:
      return { ...state, result: action.payload };
    default:
      return state;
  }
};
